import React from "react";
import * as Modal from '../../common/components/modal/modalDialog';
import { createMuiTheme, MuiThemeProvider, Button } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import { blue } from "@material-ui/core/colors";
import Translate from "../../common/functions/translate";
import LocalClientsService from "../../services/localDataServices/localClientsService";
import Spinner from "../../common/components/spinner/spinner";
import { OfferStepModel } from "../../models/offer/offerStepModel";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { OfferStatus } from "../../common/enums";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { DropdownModel } from "../../models/dropdownModel";
import MenuItem from '@material-ui/core/MenuItem';

interface IProps {
    isOpen: boolean;
    toggle: any;
    offer: OfferStepModel;
    onChangeStatus: any
}

interface IState {
    isLoading: boolean,
    currentStatus: number,
}

const theme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            marginNormal: {
                marginTop: 5,
                marginBottom: 0,
                width: '100%'
            },
            root: {
                width: '100%',
            }
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: '0px',
            }
        },
        MuiDialog: {
            paper: {
                margin: 0,
                maxWidth: '90% !important',
                minHeight: 350,
            },
            paperFullWidth: {
                width: '50%'
            }
        },
    },
    palette: {
        primary: blue
    }
})

class ChangeStatusDialog extends React.Component<IProps, IState> {
    localClientsService = new LocalClientsService();

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            currentStatus: this.props.offer.offerStatusId,
        }
    }

    componentDidMount() {

    }

    handleChange = (value) => {
        this.setState({ currentStatus: value })
    }

    getOfferStatuses = (): Array<DropdownModel> => {
        let statuses = new Array<DropdownModel>(0);

        if (this.props.offer.offerStatusId !== OfferStatus.Expired) {
            statuses = statuses.concat(HelperFunctions.enumToDropdownArray(OfferStatus, true)
                .filter(c => c.value === OfferStatus.NewOffer || c.value === OfferStatus.Accepted || c.value === this.props.offer.offerStatusId));
        } else {
            statuses = statuses.concat(HelperFunctions.enumToDropdownArray(OfferStatus, true)
                .filter(c => c.value === OfferStatus.NewOffer || c.value === this.props.offer.offerStatusId));
        }

        return statuses;
    }

    handleStatusChange = () => {
        if (this.state.currentStatus !== this.props.offer.offerStatusId) {
            this.props.onChangeStatus(this.state.currentStatus);
        } else {
            this.props.toggle(false);
        }
    }


    render() {
        const { isLoading, currentStatus } = this.state;

        const canChangeStatus = this.props.offer.offerStatusId === OfferStatus.NewOffer || this.props.offer.offerStatusId === OfferStatus.Expired

        return (
            <MuiThemeProvider theme={theme}>
                <Dialog
                    open={this.props.isOpen}
                    onClose={() => this.props.toggle(false)}
                    fullWidth
                    disableBackdropClick={true}>
                    <Modal.DialogTitle id="customized-dialog-title" onClose={() => this.props.toggle(false)}>{Translate('Offer status')}</Modal.DialogTitle>
                    <Modal.DialogContent>
                        {isLoading ? <Spinner /> : null}

                        <div>
                            {canChangeStatus
                                ? <div style={{ width: "30%", minWidth: "200px" }}>
                                    <FormControl>
                                        <InputLabel htmlFor="offer-status-label">{Translate("Status")}</InputLabel>
                                        <Select
                                            value={currentStatus ? currentStatus : ''}
                                            onChange={(e) => this.handleChange(e.target.value)}
                                            inputProps={{
                                                id: 'offer-status-label'
                                            }}
                                            style={{ marginBottom: 20 }}
                                        >
                                            {
                                                this.getOfferStatuses().map(m => <MenuItem key={m.value + 'status'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                                            }
                                        </Select>
                                    </FormControl>
                                </div>
                                : null}

                            {this.props.offer.statusHistory && this.props.offer.statusHistory.length > 0
                                ? <Table stickyHeader size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><strong>{Translate('Date')}</strong></TableCell>
                                            <TableCell><strong>{Translate('Status')}</strong></TableCell>
                                            <TableCell><strong>{Translate('User')}</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.props.offer.statusHistory.map((s, i) => {
                                            return (
                                                <TableRow key={i}>
                                                    <TableCell>
                                                        {HelperFunctions.formatDateTimeAsString(new Date(s.date))}
                                                    </TableCell>
                                                    <TableCell>
                                                        {HelperFunctions.getEnumLabel(s.statusId, OfferStatus, true)}
                                                    </TableCell>
                                                    <TableCell>
                                                        {s.user ? s.user : Translate('Changed by system')}
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                                : null}
                        </div>
                    </Modal.DialogContent>
                    <Modal.DialogActions>
                        <div>
                            <Button onClick={() => this.props.toggle(false)} variant="contained" style={{ marginRight: 10 }}>
                                {canChangeStatus ? Translate("Cancel") : Translate('Close')}
                            </Button>
                            {canChangeStatus
                                ? <Button color="primary"
                                    variant="contained"
                                    onClick={this.handleStatusChange}>
                                    {Translate('Save')}
                                </Button>
                                : null}

                        </div>
                    </Modal.DialogActions>
                </Dialog>
            </MuiThemeProvider>
        )
    }
}

export default ChangeStatusDialog